module.exports = __webpack_public_path__ + "media/ring.a398964d.mp3";